export default __webpack_public_path__ + "static/media/power_alerts_our_gpa.6915bab3.png";